import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getPaymentFieldLabelText, hasFormFieldErrors } from '../PaymentForm/helpers';
import { MopActionWrapper, LinkWrapper, LinkWithDisabledStyle } from '../PaymentForm/styled';
import { VenmoUsernameWrapper, UserName } from './styled';
import { useAppSelector } from '../../hooks/useAppSelector';
import { paymentSelector } from '../../redux/PaymentState/PaymentState.selectors';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import CardLogo from '../CardLogo';
import { CardTypes } from '../../constants/PaymentTypes';
import VerifyAddress from '../VerifyAddress';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { getString } from '../../constants/Strings';
import { CustomColorOutlineButton } from '../common/styled/CustomColorOutlineButton';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { setAppMode } from '../../redux/AppModeState/AppModeState.actions';
import { venmoInitialize } from '../../redux/MopOnFileState/MopOnFileState.actions';
import { onAddVenmoClick, venmoSubmitMop } from './helper';
import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
export var VenmoView = function VenmoView(props) {
  var username = props.username,
    goBackMode = props.goBackMode,
    isInitializing = props.isInitializing;
  var config = useAppSelector(configSelector);
  var payment = useAppSelector(paymentSelector);
  var mopOnFile = useAppSelector(mopOnFileSelector);
  var ui = config.ui,
    paymentForm = config.paymentForm,
    rioNamespace = config.rioNamespace;
  var _ref = ui,
    showSubmitButton = _ref.showSubmitButton;
  var formFields = payment.formFields,
    isLoading = payment.isLoading;
  var venmo = mopOnFile.venmo,
    paymentMethods = mopOnFile.paymentMethods;
  var venmoSubmit = venmo === null || venmo === void 0 ? void 0 : venmo.venmoSubmit;
  var hasMops = !!(paymentMethods.length > 0);
  var hasFormErrors = hasFormFieldErrors(formFields);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    addVenmoDisabled = _useState2[0],
    setAddVenmoDisabled = _useState2[1];
  var dispatch = useDispatch();
  useEffect(function () {
    // Rio Event for Venmo view component
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.VENMO_VIEW_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, []);
  useEffect(function () {
    /* istanbul ignore next */
    hasFormErrors && setAddVenmoDisabled(false);
  }, [hasFormErrors]);

  // Submit venmo mop when venmoSubmit is true
  useEffect(function () {
    venmoSubmit && venmoSubmitMop({
      payment: payment,
      mopOnFile: mopOnFile,
      dispatch: dispatch
    });
  }, [venmoSubmit]);

  /* istanbul ignore next */
  var onCancelClick = function onCancelClick() {
    dispatch(setAppMode({
      mode: goBackMode,
      goBackMode: goBackMode
    }));
    dispatch(venmoInitialize({
      venmoInitialized: false
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VenmoUsernameWrapper, null, /*#__PURE__*/React.createElement(CardLogo, {
    dataTest: DataTestAttributes.VENMO_CARD,
    cardType: CardTypes.VENMO,
    valid: true,
    isMopContainer: false
  }), /*#__PURE__*/React.createElement(UserName, null, username)), /*#__PURE__*/React.createElement(VerifyAddress, null), (hasMops || showSubmitButton) && /*#__PURE__*/React.createElement(MopActionWrapper, null, hasMops && /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(LinkWithDisabledStyle, {
    "data-test": DataTestAttributes.ADD_VENMO_CANCEL_BUTTON,
    hasButtonBehavior: true,
    onClick: onCancelClick,
    href: isInitializing ? '' : '#',
    role: 'button',
    "aria-disabled": isInitializing,
    disabled: isInitializing
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CANCEL) || getString('APP.MOPONFILE.CANCEL'))), /*#__PURE__*/React.createElement(CustomColorOutlineButton, {
    size: 'small',
    onClick: function onClick(event) {
      return onAddVenmoClick({
        event: event,
        dispatch: dispatch
      });
    },
    disabled: addVenmoDisabled || isLoading,
    "data-test": DataTestAttributes.ADD_VENMO_BUTTON,
    disableHoverAnimation: true
  }, /*#__PURE__*/React.createElement("span", null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ADD_VENMO) || getString("APP.FORM.BUTTON.VENMO")))));
};
export default VenmoView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VenmoView/index.js
// module id = 4548
// module chunks = 11